export const HOME_BASE = '/';

export const ROUTES = {
  HOME: HOME_BASE,
} as const;
